import { Box, Button, Checkbox, Grid, Typography } from "@mui/material";
import { useUser } from "../../../../../contexts/user.context";
import { useState } from "react";
import { mobilizeiStoresService } from "../../../../../services/mobilizei/stores.service";
import _ from "lodash";
import useAppInfo from "../../../../../hooks/appInfo.hook";
import { storeStatus } from '../../../../../utils/constants';

export default function InviteContent({ blocked }) {
  const { user, setUser } = useUser();
  const { appInfo } = useAppInfo();

  const isDisabled = (appInfo?.storeStatus !== storeStatus.ACTIVE) || blocked;

  const [isPartnerAgreementChecked, setIsPartnerAgreementChecked] = useState(false);

  function onSubmit() {
    mobilizeiStoresService
      .updateStoreById(user?.store?.platformId, user?.store?.id, {
        platforms: {
          android: {
            isInvitationSent: true,
          }
        }
      }).catch(() => null)

    // Set the local user properties
    setUser({
      ...user,
      store: {
        ...user?.store,
        platforms: {
          ...user?.store?.platforms,
          android: {
            ...user?.store?.platforms?.android,
            isInvitationSent: true,
          }
        }
      }
    })
  }

  return (
    <Box>
      {user?.store?.platforms?.android?.isInvitationSent
        ? (
          <Grid
            container
            display={'flex'}
            flexDirection={'column'}
            spacing={2}
          >
            <Grid item>
              <Typography variant="body1">
                Um convite de acesso à sua conta de desenvolvedor foi enviado para nossa equipe.
              </Typography>
            </Grid>
          </Grid>
        )
        : (
          <Grid
            container
            component="form"
            display={'flex'}
            flexDirection={'column'}
            spacing={2}
            onSubmit={onSubmit}
          >

            <Grid item xs={12}>
              <Typography variant="body1" mb={2}>
                Após criar a conta e concluir todas as verificações,
                <strong> o próximo passo é nos enviar um convite de acesso à sua conta de desenvolvedor Google</strong>.
              </Typography>

              <Typography variant="body1" mb={2}>
                Para isso, é só seguir
                <a
                  href="https://mobilizei.com.br/tutoriais/convidando-a-mobilizei-para-sua-conta-google-play"
                  target="_blank"> estas instruções.</a>
              </Typography>

              <Box display='flex' alignItems='center' marginBottom={1} sx={{ cursor: 'pointer' }}>
                <Checkbox checked={isPartnerAgreementChecked} sx={{ paddingLeft: 0 }} disabled={isDisabled} onClick={() => setIsPartnerAgreementChecked(!isPartnerAgreementChecked)} />
                <Typography align="justify" variant="body1">
                  Enviei um convite de acesso à minha conta de desenvolvedor do Google Play ao e-mail apps@mobilizei.com.br.
                </Typography>
              </Box>
            </Grid>

            <Grid item>
              <Box display='flex' justifyContent='center' marginTop={4} width='100%'>
                <Button disabled={!isPartnerAgreementChecked || isDisabled}
                  variant="contained" type="submit">
                  próximo passo
                </Button>
              </Box>
            </Grid>

            {blocked &&
              <Grid item>
                <Box display='flex' justifyContent='center' marginTop={0} width='100%'>
                  <Typography variant="body1" fontWeight='bold' marginTop={1}>
                    Finalize a criação da sua conta de desenvolvedor para continuar
                  </Typography>
                </Box>
              </Grid>
            }
          </Grid>
        )}
    </Box>
  )
}